import { DriverLicenseStatusModel } from "../drivers/drivers.model";

/**
 * Created by Valdo on 16.03.2017
 */
export class OnDemandDriverModel {

  public isfollowup: boolean;
  public followupdate: string;
  public startdate: string;
  public device: string;
  public devicemodel: string;
  public hassignature: boolean;
  public signaturephoto: string;
  public hacklicence: string;
  public pin: number;
  public ssn: string;
  public streetaddress: string;
  public roomaptnumber: string;
  public city: string;
  public state: string;
  public zip: string;
  public latitude: number;
  public longitude: number;
  public gender: string;
  public profilephoto: string;
  public driverlicense: string;
  public driverlicencephoto: string;
  public driverlicensephoto?: string;
  public licenseexpiryformatted: string;
  public licenseexpiry: string;
  public dobformatted: string;
  public dobformattedstandard: string;
  public dob: string;
  public licensestate: string;
  public lastappusageformatted: string;
  public photo: string;
  public onroute: boolean;
  public companyid: number;
  public userprofileid: number;
  public fullname: string;
  public firstname: string;
  public middleinitial: string;
  public lastname: string;
  public phone: string;
  public emailaddress: string;
  public isactive: boolean;
  public driverstatusid: number;
  public applicationstatusid: number;
  public bankid: number;
  public accountnumber: string;
  public routingnumber: string;
  public isconvictedoffelony: boolean;
  public iscitizen: boolean;
  public islicensemorethanyear: boolean;
  public rejectionstatusid: number;
  public inactivateReason?: string;
  public ddcsenddate: string;
  public cprsenddate: string;
  public islicensevalid: boolean;
  public driverlicensestatus?: DriverLicenseStatusModel;
  public note: string;
  constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/on-demand-drivers.model.ts